<template>
  <div class="baseInfo-page">
    <div class="baseInfo-body">
      <el-form :model="ruleForm" ref="ruleForm" :rules="isAdd != 3 ? rules : null" label-width="auto" class="demo-ruleForm">
        <form-title :required="isAdd == 3 ? false : true" style="font-weight:bold;">建筑类型</form-title>
        <div class="form-radio-box">
          <div class="form-radio">
            <el-radio-group v-model="buildRadioParent" size="small" :disabled="isAdd == 3" @input="handleRadioParent">
              <el-radio-button label="civilBuild">民用住宅</el-radio-button>
              <el-radio-button label="commercialBuild">商用建筑</el-radio-button>
              <el-radio-button label="publicBuild">公用建筑</el-radio-button>
            </el-radio-group>
          </div>
          <div class="form-radio-group">
            <el-form-item label-width="auto" prop="buildingType">
              <el-radio-group v-model="ruleForm.buildingType" :disabled="isAdd == 3">
                <el-radio :label="i.id" v-for="i in buildList" :key="i.id">{{ i.name }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </div>
        <form-title style="font-weight:bold;">项目信息</form-title>
        <div class="project-box">
          <el-form-item label="项目编号" style="width: 100%">
            <span>{{ ruleForm.projectCode }}</span>
          </el-form-item>
          <el-form-item label="用户编码" prop="userCode" style="width: 100%">
            <el-input
              v-model.trim="ruleForm.userCode"
              :disabled="isAdd == 3"
              clearable
              maxlength="64"
              placeholder="请输入（可为空）"
            />
          </el-form-item>
          <el-form-item label="项目状态" prop="status">
            <el-select v-model="ruleForm.status" style="width: 100%" :disabled="isAdd == 3" clearable>
              <el-option label="在建" :value="10" />
              <el-option label="试运行" :value="20" />
              <el-option label="已交付" :value="30" />
            </el-select>
          </el-form-item>
          <el-form-item label="项目名称" prop="projectName" style="width: 100%">
            <el-input
              v-model.trim="ruleForm.projectName"
              :disabled="isAdd == 3"
              clearable
              maxlength="64"
              placeholder="请输入"
            /> 
          </el-form-item>
          <el-form-item label="所属组织" prop="orgId">
            <el-cascader
              :options="orgList"
              :props="orgProps"
              v-model="ruleForm.orgId"
              style="width: 100%"
              :disabled="isAdd == 3"
              clearable
              placeholder="请选择"
            />
          </el-form-item>
          <el-form-item label="代运营方" prop="operator" style="width: 100%">
            <el-input
              v-model.trim="ruleForm.operator"
              :disabled="isAdd == 3"
              clearable
              maxlength="64"
              placeholder="请输入"
            />
          </el-form-item>
          <el-form-item label="客户姓名" prop="contactPerson" style="width: 100%">
            <el-input
              v-model.trim="ruleForm.contactPerson"
              :disabled="isAdd == 3"
              clearable
              maxlength="64"
              placeholder="请输入"
            />
          </el-form-item>
          <el-form-item label="联系电话" prop="contactPhone" style="width: 100%">
            <el-input
              v-model.trim.number="ruleForm.contactPhone"
              :disabled="isAdd == 3"
              clearable
              :controls="false"
              :maxlength="12"
              :max="11"
              placeholder="请输入"
            />
          </el-form-item>
          <div class="areaBox">
            <el-form-item label="所在地区" :required="isAdd == 3 ? false : true">
              <el-select
                v-model="ruleForm.country"
                style="width: 116px; margin-right: 20px"
                :disabled="isAdd == 3"
              >
                <el-option
                  v-for="(item, index) in countryList"
                  :key="index"
                  :label="item.name"
                  :value="item.name"
                />
              </el-select>
            </el-form-item>
            <el-form-item label-width="auto" prop="province">
              <el-select
                v-model="ruleForm.province"
                style="width: 116px; margin-right: 20px"
                @change="provinceChange"
                :disabled="isAdd == 3"
                filterable
                clearable
                placeholder="请选择省"
                @clear="clearProvince"
              >
                <el-option
                  v-for="(item, index) in provinceList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label-width="auto" prop="city">
              <el-select
                v-model="ruleForm.city"
                style="width: 116px; margin-right: 20px"
                @change="cityChange"
                :disabled="isAdd == 3"
                filterable
                clearable
                placeholder="请选择市"
                @clear="clearCity"
              >
                <el-option
                  v-for="(item, index) in cityList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label-width="auto" prop="area">
              <el-select
                v-model="ruleForm.area"
                style="width: 116px; margin-right: 20px"
                :disabled="isAdd == 3"
                filterable
                clearable
                placeholder="请选择区"
              >
                <el-option
                  v-for="(item, index) in areaList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label-width="auto" style="width: 100%">
              <el-input
                v-model.trim="ruleForm.town"
                :disabled="isAdd == 3"
                clearable
                style="width: 100%"
                placeholder="请填写街道"
              />
            </el-form-item>
          </div>    
          <el-form-item label="详细地址" prop="address" style="width: 100%">
            <el-input
              v-model.trim="ruleForm.address"
              :disabled="isAdd == 3"
              clearable
              style="width: 100%"
              maxlength="64"
              placeholder="请输入"
            />
          </el-form-item>
          <el-form-item label="系统类型" prop="systemType">
            <el-select
              v-model="ruleForm.systemType"
              style="width: 100%"
              :disabled="isAdd == 3"
              filterable
              clearable
              placeholder="请选择">
              <el-option
                v-for="item in systemTypeList"
                :key="item.name"
                :label="item.name"
                :value="item.name"/> 
            </el-select>
          </el-form-item> 
          <el-form-item label="项目图片" prop="projectImage">
            <DiluUploadImg accept=".png,.jpg"  :limit="1" :fileList="photoList"  @remove="removePhoto" @success="successPhoto"/>
          </el-form-item>
        </div>
        <br/>
      </el-form>
    </div>
    <span v-if="isAdd == '1' || isAdd == '2'" slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submit">保存</el-button>
      <el-button type="text" @click="handleClose">重置</el-button>
    </span>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { DateToStr } from "@/utils/util/util";
import build from "../js/build";
import systemTypeList from "../js/systemType";
import FormTitle from "../components/FormTitle.vue";
import FormSubTitle from "../components/FormSubTitle.vue";
import DiluUploadImg from "@/components/public/dilu-uploadImg.vue";

export default {
  components: {
    FormTitle,
    FormSubTitle,
    DiluUploadImg,
  },
  data() {
    return {
      buildRadioParent: "civilBuild",
      ruleForm: {
        id: null, //自增ID
        buildingType: null, // 建筑类型
        projectCode: "", //项目编号
        userCode: "", //用户编码
        status: 10, //项目状态 10：在建，20：试运行，30：已交付
        projectName: "", //项目名称
        orgId: "", // 所属组织
        operator: "", // 运营方
        contactPerson: "", //客户姓名
        contactPhone: "", //联系电话
        country: "中国", //国家
        province: "", //省份
        city: "", //城市
        area: "", //区县
        town: "", // 街道
        systemType: "",    // 系统类型
        priceNormal: 0.55, // 正常电价
        address: "",       // 详细地址
        projectImage: null,  //项目图片
        realChart: null, //设备参数
      },
      photoList: [],
      buildList: [], // 建筑列表
      province: "", //当前省份
      city: "", //当前城市
      provinceList: [], //省份列表
      cityList: [], //城市列表
      areaList: [], //区县列表
      streetList: [], // 街道列表
      countryList: [{ name: "中国" }],
      systemTypeList, // 系统类型
      isAdd: 1, // 1新增 2编辑 3查看
      currentData: {}, // 当前行数据
      orgList: [], // 所属组织数据列表
      orgProps: {
        children: "orgList",
        label: "name",
        value: "id",
        checkStrictly: true,
      },
      // 表单校验规则
      rules: {
        projectImage: [
          { required: false, message: "请上传项目图片", trigger: "change" },
        ],
        buildingType: [
          { required: true, message: "请选择建筑类型", trigger: "change" },
        ],
        status: [
          { required: true, message: "请选择项目状态", trigger: "change" },
        ],
        projectName: [
          { required: true, message: "请输入项目名称", trigger: "blur" },
        ],
        orgId: [
          { required: true, message: "请选择所属组织", trigger: "change" },
        ],
        operator: [
          { required: false, message: "请输入运营方", trigger: "blur" },
        ],
        contactPerson: [
          { required: false, message: "请输入联系人", trigger: "blur" },
        ],
        contactPhone: [
          { required: false, message: "请输入联系电话", trigger: "blur" },
        ],
        province: [{ required: true, message: "请选择省", trigger: "change" }],
        city: [{ required: true, message: "请选择市", trigger: "change" }],
        area: [{ required: true, message: "请选择地区", trigger: "change" }],
        systemType: [
          { required: false, message: "请选择系统类型", trigger: "change" },
        ],
        address: [
          { required: false, message: "请输入详细地址", trigger: "blur" },
        ],
      }
    };
  },
  computed: {
    ...mapState(["platformData"]),
    ...mapState(["projectCurrentRowData"]),
  },
  mounted() {
    const { isAdd } = this.$route.query;
    this.isAdd = isAdd;
    this.currentData = this.projectCurrentRowData;
    this.getProvince();
    this.showInit();
    this.listOrg();
    this.setBuildList();
  },
  methods: {
    removePhoto(e) {
      const i = this.photoList.findIndex((x) => x.name == e);
      this.photoList.splice(i, 1);
      this.ruleForm.projectImage = null;
    },
    successPhoto(e) {
      this.ruleForm.projectImage = e.url;
      this.photoList = e.fileList;
    },
    // PN.<租户ID>-YYMMDDHHmmss
    genProjectCode() {
      const tenantId = this.platformData.id;
      const dateTime = DateToStr(new Date()).split(" ");
      const year = dateTime[0].split("-").join("");
      const time = dateTime[1].split(":").join("");
      if (tenantId!=undefined&&tenantId!=null) {
        this.ruleForm.projectCode = `PN.${tenantId}-${year.slice(2)}${time}`;
        return true;
      } else {
        return false;
      }
    },
    //部门管理-查询所有部门
    listOrg() {
      this.request.listOrg().then((res) => {
        if (res.code == 0) {
          this.orgList = [res.data];
        }
      });
    },
    createProject() {
      this.ruleForm = {
        id: null, //自增ID
        buildingType: null, // 建筑类型
        projectCode: "", //项目编号
        userCode: "", //用户编码
        status: 10, //项目状态（10：正常使用，20：在建，30：交付）
        projectName: "", //项目名称
        orgId: "", // 所属组织
        priceNormal: 0.55, // 正常电价
        operator: "", // 运营方
        contactPerson: "", //客户姓名
        contactPhone: "", //联系电话
        country: "中国", //国家
        province: "", //省份
        city: "", //城市
        area: "", //区县
        town: "", // 街道
        systemType: "", // 系统类型
        address: "", //详细地址
        realChart: null, //设备参数
      };
      // 设置项目编号
      if (this.genProjectCode()) {
        // 设置建筑类型
        this.buildRadioParent = "civilBuild";
        this.setBuildList();
      } else {
        this.$message({
          message: "租户ID获取失败，请重新登录后创建项目",
          type: "warning",
        });
      }
    },
    editProject() {
      const currentData = this.currentData;
      // 建筑类型
      const [buildTypeParent, buildingType] = currentData.buildingType || [];
      this.buildRadioParent = buildTypeParent
        ? build.buildEnum[buildTypeParent]
        : "civilBuild";
      // 省市区
      const { province, city, area } = currentData;
      const provinceId = province.split(",")[0]*1;
      const cityId = city.split(",")[0]*1;
      var areaId = null;
      if (area!=null&&area!=undefined&&area.length>0) {
        areaId=area.split(",")[0]*1;
      }
      Object.assign(this.ruleForm, {
        ...currentData,
        buildingType,
        province: provinceId,
        city: cityId,
        area: areaId
      });
      this.photoList = [];
      if (this.ruleForm.projectImage!=null) {
        this.photoList.push({
          url: this.ruleForm.projectImage,
          name: "projectImage"
        });
      }
      this.provinceChange(provinceId);
      this.cityChange(cityId);
    },
    //初始显示
    showInit() {
      if (this.isAdd == 1) {
        this.createProject();
      } else if (this.isAdd == 2 || this.isAdd == 3) {
        this.editProject();
      }
    },
    getProvince() {
      this.request.getProvince().then((res) => {
        this.provinceList = res.data;
      });
    },
    getCity() {
      let params = {};
      params["province"] = this.ruleForm.province;
      this.request.getCity(params).then((res) => {
        this.cityList = res.data;
      });
    },
    getArea() {
      let params = {};
      params["city"] = this.ruleForm.city;
      this.request.getArea(params).then((res) => {
        this.areaList = res.data;
      });

    },
    handleClose() {
      this.$refs["ruleForm"].resetFields();
      this.createProject();
    },
    provinceChange(value) {
      for (let item of this.provinceList) {
        if (item["name"] == value) {
          this.province = item["id"];
        }
      }
      this.getCity();
    },
    cityChange(value) {
      for (let item of this.cityList) {
        if (item["name"] == value) {
          this.city = item["id"];
        }
      }
      this.getArea();
    },
    clearProvince() {
      this.ruleForm.city = "";
      this.ruleForm.area = "";
    },
    clearCity() {
      this.ruleForm.area = "";
    },
    //确定
    submit() {
      if (this.ruleForm.projectCode==undefined||this.ruleForm.projectCode==null||this.ruleForm.projectCode=='') {
        this.$message({
          message: "租户ID获取失败，请重新登录后创建项目",
          type: "warning",
        });
      } else {
        const cloneRuleForm = JSON.parse(JSON.stringify(this.ruleForm));
        this.$refs["ruleForm"].validate((valid) => {
          if (valid) {
            const buildingType = cloneRuleForm.buildingType;
            const { province, city, area } = cloneRuleForm;
            const findProvince = this.provinceList.find(i => i.id === province);
            const provinceName = findProvince ? findProvince.name : "";
            const findCity = this.cityList.find(i => i.id === city);
            const cityName = findCity ? findCity.name : "";
            const findArea = this.areaList.find(i => i.id === area);
            const areaName = findArea ? findArea.name : "";
            const postData = Object.assign(cloneRuleForm, {
              buildingType: [build[this.buildRadioParent].id, buildingType],
              province: province + "," + provinceName,
              city: city + "," + cityName,
              area: area + "," + areaName
            });
            let api = null,
              message = "";
            if (this.isAdd == 1) {
              api = this.request.projectAdd;
              message = "新增成功";
            } else {
              api = this.request.projectEdit;
              message = "编辑成功";
            }
            this.submitData(api, postData, message);
          }
        });
      }
    },
    submitData(api, postData, message) {
      api(postData).then((res) => {
        if (res.code == 0) {
          this.$message.success(message);
          setTimeout(() => {
            this.$emit("projectList");
            this.$router.go(-1);
          }, 500);
        }
      });
    },
    // 切换建筑类型 设置具体建筑
    setBuildList() {
      this.buildList = build[this.buildRadioParent].typeList;
    },
    handleRadioParent() {
      this.ruleForm.buildingType = null;
      this.setBuildList();
    }
  },
};
</script>

<style scoped lang="scss">

.baseInfo-page {
  overflow: hidden;
}
.baseInfo-body {
  box-sizing: border-box;
  background-color: white;
  padding-right: 24px;
  height: calc(100% - 132px);
  width: 100%;
  overflow: auto;

  .form-radio-box {
    margin: 16px 0 30px;
    .form-radio {
      margin-bottom: 24px;
    }
  }

  .icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    vertical-align: middle;
    margin-right: 8px;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .project-box {
    margin: 20px 0;
    .areaBox {
      display: flex;
      justify-content: flex-start;
    }
  }

  .form-sub-title {
    margin: 20px 0;
  }

}

.dialog-footer {
  margin-top: 20px;
  margin-bottom: 20px;
  width: 560px;
  text-align: left;
  display: block;
  > :nth-child(1) {
    width: 300px;
    height: 32px;
    line-height: 32px;
    border-radius: 2px;
    opacity: 1;
    padding: 0;
    background: #3456ff;
  }
  > :nth-child(2) {
    font-family: "microsoft yahei ui","microsoft yahei";
    font-size: 14px;
    color: #666666;
    margin-left: 56px;
  }
}
</style>
